import React, {Component} from "react"

export default class TabSegments extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeSegment: 0
    }
  }

  render() {
    return (
      <div className="sh-tab-segments">
        <div className="sh-tab-segments-options">{this.renderLabels()}</div>
        {this.renderActiveChild()}
      </div>
    )
  }

  activeClass(index) {
    return index === this.state.activeSegment ? " active" : ""
  }

  renderLabels() {
    return React.Children.map(this.props.children, (option, index) => (
      <span
        className={`option${this.activeClass(index)}`}
        onClick={() => {
          this.props.onSetActiveTab(option.props.label)
          this.setState({activeSegment: index})
        }}
      >
        {option.props.label}
      </span>
    ))
  }

  renderActiveChild() {
    const activeChild = React.Children.toArray(this.props.children).filter(
      (option, index) => index === this.state.activeSegment
    )[0]

    return (
      <div className="sh-tab-segments-segment active">
        {activeChild.props.children}
      </div>
    )
  }
}

TabSegments.Segment = ""



// WEBPACK FOOTER //
// ./src/components/TabSegments.js